// Full documentation:
// https://code.aptitude.com/aptitude-source/aptitude/wikis/component-tray
export const TrayComponent = {
  transclude: {
    title: '?trayTitle',
    label: '?trayLabel'
  },
  bindings: {
    attachments: '<'
  },
  controller: class {
    isExpanded: boolean = false;
  },
  template: `<div class="tray">
               <div class="title ellipsis" ng-transclude="title"></div>
               <div class="tray-label">
                <div data-test-selector="expand-button" class="tray-control expand-button" tabindex="0" aria-label="expand and collapse request for pricing progress timeline details" ng-click="$ctrl.isExpanded = !$ctrl.isExpanded">
                   <i class="apt-minus-circle-icon fa-lg fas apt-green" ng-if="$ctrl.isExpanded"></i>
                   <i class="apt-plus-circle-icon fa-lg fas apt-green" ng-if="!$ctrl.isExpanded"></i>
                </div>
                <div ng-transclude="label"></div>
               </div>
               <div class="title counterbalance" ng-transclude="title"></div>
             </div>
             <div class="tray-contents" ng-transclude ng-if="$ctrl.isExpanded"></div>`
};
